import ApiClient from "./ApiClient";

export default class UserApiClient {
  apiClient: ApiClient;
  urlPrefix: string = "users/";

  constructor() {
    this.apiClient = new ApiClient();
  }

  async authorize(aaiToken: string) {
    const result = await this.apiClient.post(this.urlPrefix + "authorize", {
      aaiToken: aaiToken
    });

    return result.token as string;
  }
}
